import { Navbar, Nav, NavDropdown, Form, FormControl, Dropdown, FormGroup, Row, Col, Tabs, Tab } from "react-bootstrap";
import logo from "../assets/images/logo.png"; 
import TimeRemNotification from "./TimeRemNotification";
import { useSelector } from "react-redux"; 
import { canView } from "../common/util/appUtils";
import { useLocation } from "react-router-dom";
import "../App.css";  
import { useEffect, useState } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
export default function NavbarComponent({ history, currentUser, setRoutesParams }) { 
  const accessContext = useSelector(state => state.UserContext.accessContext);
  const location = useLocation();
  const activeStyle = { color: "#fff !important", fontWeight: "900", textShadow: "1px 3px #416060", fontSize: "18px", backgroundColor: "#0180C7",
    textDecorationLine: "underline",
    textUnderlineOffset: "8px", textDecorationThickness: "2px", textDecorationColor: "#dee2e6" };
  const defaultStyle = { color: "#fff", fontSize: "18px" };

  const getStyle = (path) => location.pathname.includes(path) ? activeStyle : defaultStyle;
  const getParentStyle = (paths) => paths.some(p => location.pathname.includes(p)) ? activeStyle : defaultStyle;
  const MAX_VISIBLE = 8;
  const NAV_ITEMS = [
    { key: "Home", label: "Home", path: "/" },
    { key: "Accounts", label: "Accounts", path: "/clientlist/Accounts/listview", perm: "Accounts" },
    { key: "Vendors", label: "Vendors", path: "/vendorlist/Vendors/listview", perm: "Vendor" },
    { key: "Deals", label: "Deals", path: "/deallist/Deals/listview", perm: "Deals" },
    { key: "Tasks", label: "Tasks", path: "/project/Tasks/defaultView", perm: "Tasks" },
    { key: "hr", label: "Time Clock", path: "/hr/timeclock", perm: "Time Clock" },
    { key: "Document", label: "Documents", path: "/access/d/Document/listview", perm: "Documents" },
    { key: "Calendar", label: "Calendar", path: "/access/Calendar/listview", perm: "Calendar" },
    { key: "Email", label: "Emails", path: "/access/e/Email/listview", perm: "Emails" },
    { key: "Contacts", label: "Contacts", path: "/" },
    { key: "Leads", label: "Leads", path: "/" },
    { key: "Quotes", label: "Quotes", path: "/" },
    { key: "Accounting", label: "Accounting", path: "/" },
  ];

  const [navItems, setNavItems] = useState(NAV_ITEMS);

  useEffect(() => {
    const saved = localStorage.getItem("navOrder");
    if (saved) {
      try {
        setNavItems(JSON.parse(saved));
      } catch {
        setNavItems(NAV_ITEMS);
      }
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("navOrder", JSON.stringify(navItems));
  }, [navItems]);

  const handleDragEnd = (result) => {
    if (!result.destination) return;

    const items = Array.from(navItems);

    const sourceIndex = result.source.index;
    const destIndex = result.destination.index;

    // restrict drag only in visible range
    if (sourceIndex >= MAX_VISIBLE || destIndex >= MAX_VISIBLE) return;

    const [moved] = items.splice(sourceIndex, 1);
    items.splice(destIndex, 0, moved);

    setNavItems(items);
  };

  const handleMoreClick = (item) => {
    const items = Array.from(navItems);

    const index = items.findIndex(i => i.key === item.key);

    // remove selected item
    const [selected] = items.splice(index, 1);

    // insert at top (or you can insert at end of visible)
    items.splice(MAX_VISIBLE - 1, 0, selected);

    setNavItems(items);
  };

  const visibleItems = navItems.slice(0, MAX_VISIBLE);
  const overflowItems = navItems.slice(MAX_VISIBLE);
  return (
    <Navbar style={{ background: "#018EE0" }} expand="lg">
                <img className="logo-img" src={logo} />
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse className="pad-left-40" id="basic-navbar-nav">
                  <Nav className="mr-auto header-navbar nav-spacing-fix">
                  <DragDropContext onDragEnd={handleDragEnd}>
                    <Droppable droppableId="nav-bar" direction="horizontal">
                      {(provided) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.droppableProps}
                          style={{ display: "flex", alignItems: "center", flex: 1, justifyContent:"space-between", gap:"10px"}}
                        >
                          {visibleItems.map((item, index) => {
                            const allowed = item.perm
                              ? canView(accessContext?.modulePermissions, item.perm)
                              : true;

                            return (
                              <Draggable key={item.key} draggableId={item.key} index={index} isDragDisabled={item.key === "Home"}>
                                {(provided) => (
                                  <div
                                   className="navbarlinkdraggablediv"
                                    ref={provided.innerRef}
                                    {...provided.draggableProps}
                                    // {...provided.dragHandleProps}
                                    {...(item.key !== "Home" ? provided.dragHandleProps : {})}
                                  >
                                    <Nav.Link
                                      onClick={() => {
                                        if (!allowed || !item.path) return;
                                        history.push({ pathname: item.path });
                                      }}
                                      className={`nav-single-item ${!allowed ? "nav-disabled" : ""}`}
                                      style={getStyle(item.key)}
                                    >
                                      {item.label}
                                    </Nav.Link>
                                  </div>
                                )}
                              </Draggable>
                            );
                          })}
                          {provided.placeholder}
                        </div>
                      )}
                    </Droppable>
                  </DragDropContext>

                  <Dropdown align="end">
                    <Dropdown.Toggle variant="link" style={{ color: "#fff" }}>
                     <span style={{ fontSize: "20px" }}>⋮</span>

                      <style>
                        {`.dropdown-toggle::after { display: none !important; }`}
                      </style>
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      {overflowItems.map(item => {
                        const allowed = item.perm
                          ? canView(accessContext?.modulePermissions, item.perm)
                          : true;

                        return (
                          <Dropdown.Item
                            key={item.key}
                            onClick={() => {
                              handleMoreClick(item);

                              if (allowed && item.path) {
                                history.push({ pathname: item.path });
                              }
                            }}
                          >
                            {item.label}
                          </Dropdown.Item>
                        );
                      })}
                    </Dropdown.Menu>
                  </Dropdown>
                  </Nav> 
                  <TimeRemNotification currentUser={currentUser} history={history} />
                </Navbar.Collapse>
              </Navbar>)
}
